<template>
  <div id="message-panel">
    <div class="message-list">
      <div class="messageBox">
        <p
          class="messageItem"
          v-for="(item,index) in messageList"
          :key="index"
          v-show="TabCardCurrent === 0 || item.from.type !== 0 "
        >
          <span
            :style="{color:(item.from.type === 1 ? '#3ECCC7' : item.from.type === 2 ? '#FFAD1E' : '#787878')}"
          >{{ setName(item) }}：</span>
          <span  v-html="changeEmImg(item)"></span>
        </p>
      </div>
    </div>
    <div class="message-sender">
      <div class="senderBox" v-show="!isFull">
        <input class="input" placeholder="和大家一起讨论一下吧" v-model="msgVal" maxlength="50" type="text" >
        <button @click="sendMsg" class="send">{{ sendBtn }}</button>
      </div>
      <div class="disableBtn" v-show="isFull" @click="toastShow">
        <p>和大家一起讨论一下吧</p>
      </div>
    </div>
    <div v-show="toastStatus" class="toastStatus">
      请在竖屏模式发表讨论
    </div>
  </div>
</template>

<script>

// eslint-disable-next-line no-undef
const { eventEmitter } = BJY;

export default {
  components: {},
  props: ['TabCardCurrent', 'isFull'],
  watch: {
    isFull() {
      this.chatHeight();
    },
  },
  data() {
    return {
      messageList: [], // 消息列表
      msgVal: '', // 输入内容
      sendBtn: '发送', // 发送弹幕按钮
      forbidAll: false, // 是否全体禁言
      forbidSelf: false, // 是否单人禁言
      namespace: `.live${Math.random()}`,
      toastStatus: false, // 横屏禁言提示
    };
  },
  methods: {
    setName(data) {
      const { type, name } = data.from;
      // 用户类型，0：学生；1：老师；2：助教
      if (type === 0) {
        if (this.getNum(name).length === 11) { // 处理用户名中包含手机号
          const phNum = this.getNum(name);
          const phnumAfter = `${phNum.substr(0, 3)}****${phNum.substr(7)}`;
          return name.replace(phNum, phnumAfter);
        }
        return name;
      } if (type === 1) {
        return '讲师';
      }
      return '助教';
    },
    getNum(text) {
      const value = text.replace(/[^0-9]/ig, '');
      return value;
    },
    sendMsg() {
      const {
        msgVal, sendBtn, forbidAll, forbidSelf,
      } = this;
      if (!msgVal.trim() || sendBtn !== '发送') return;
      if (forbidAll) {
        this.$toast('全体禁言中');
        return;
      }
      if (forbidSelf) {
        this.$toast('您已被禁言');
        return;
      }
      // 发送弹幕逻辑。。。
      eventEmitter.trigger( // 发送公聊
        eventEmitter.MESSAGE_SEND + this.namespace,
        {
          content: msgVal,
        },
      );
      this.msgVal = '';
      this.sendBtn = 2;
      this.timer = setInterval(() => {
        this.sendBtn -= 1;
        if (this.sendBtn < 1) {
          this.sendBtn = '发送';
          clearInterval(this.timer);
        }
      }, 1000);
    },
    chatHeight() { // 重新计算当前聊天高度
      setTimeout(() => {
        // 竖屏时
        // eslint-disable-next-line no-undef
        const height = $('.messageBox').height() * 200;
        const messageBoxDOM = document.getElementsByClassName('messageBox')[0];
        messageBoxDOM.scrollTop = height;
      }, 200);
    },
    changeEmImg(data) {
      const paramData = data.data;
      let { content } = data;
      /* eslint-disable */
      const { parser } = BJY;
      const renderEmoji = BJY.data.emotion.render;

      if (paramData) {
        const {
          type, url, width,key
        } = paramData;
        if (type === 'emoji') {
          content = renderEmoji(
            key,
            url || parser.getEmojiUrlByKey(key),
          );
        } else if(type === 'image'){
          const winW = window.innerWidth;
          let w = '300px';
          if (width < winW) {
            w = width;
          } else {
            w = '100%';
          }
          return `<img src=${url} style="width: ${w};vertical-align: middle" />`;
        }
      } else {
        content = $.trim(content);

        if (parser.isPureText(content)) {
          content = parser.encodeHTML(content);
          content = parser.parseBreakline(content);
          content = parser.parseLink(content, function (original) {
            var url = original
            if (url.indexOf('http') !== 0) {
              url = 'http://' + url
            }
            return '<a class="bjy-link" target="_target" style="color: #0091FF" href="' + url + '">' + original + '</a>'
          }) 
          content = parser.parseEmoji(content, renderEmoji);
        } else {
          content = parser.parseEmoji(content, renderEmoji);
        }
      }
      return content;
    },
    toastShow() {
      this.toastStatus = true;
      setTimeout(() => {
        this.toastStatus = false;
      }, 2000);
    },
  },
  created() {
    eventEmitter
      .on(
        eventEmitter.MESSAGE_RECEIVE + this.namespace,
        (e, data) => {
          this.messageList = [...this.messageList, data];
          this.chatHeight();
        },
      )
      .on( // 获取历史消息
        eventEmitter.MESSAGE_PULL_RES + this.namespace,
        (e, data) => {
          this.messageList = data.messageList?.reverse();
          setTimeout(() => {
            this.chatHeight();
          }, 200);
        },
      )
      .on( // 是否全体禁言
        eventEmitter.MESSAGE_SEND_FORBID_ALL_CHANGE + this.namespace,
        (e, data) => {
          this.forbidAll = data?.forbidAll;
          if (this.forbidAll) this.$toast('全体禁言中');
        },
      )
      .on( // 是否单人禁言
        eventEmitter.MESSAGE_SEND_FORBID + this.namespace,
        (e, data) => {
          this.forbidSelf = data.duration > -1;
          if (this.forbidSelf) this.$toast('您已被禁言');
        },
      );
    eventEmitter.trigger(
      eventEmitter.MESSAGE_PULL_REQ, // 拉取历史消息
    );
    eventEmitter.trigger(
      eventEmitter.MESSAGE_SEND_FORBID_ALL_CHANGE_TRIGGER, // 全员禁言事件，用于设置是否设置全员禁言
    );
    eventEmitter.trigger(
      eventEmitter.USER_STATE_REQ, // 查询用户禁言状态
    );
    eventEmitter.trigger(
      eventEmitter.MESSAGE_SEND_FORBID_TRIGGER, // 用户禁言事件，用于设置是否禁言用户
    );
  },
  mounted() {

  },
};
</script>

<style lang='scss'>
//@import url(); 引入公共css类
#message-panel {
  position: relative;
  width: 100%;
  height: 100%;
  .message-list {
    position: absolute;
    top: 0;
    bottom: 150px;
    box-sizing: border-box;
    width: 100%;
    height: unset;
    .messageBox {
      width: 100%;
      height: 100%;
      overflow-y: auto;
      .messageItem {
        width: 100%;
        padding: 10px 30px;
        color: #787878;
        font-size: 28px;
        line-height: 40px;
        word-break: break-all;
      }
    }

  }

  .message-sender {
    position: absolute;
    bottom: 0;
    display: flex;
    align-items: center;
    width: 100%;
    height: 150px;
    padding: 0 36px;
    background: #FFF;
    box-shadow: 0 0 5px #ccc;
    .senderBox {
      display: flex;
      justify-content: space-between;
      width: 100%;
      .input {
        width: 65%;
        height: 70px;
        padding: 0 32px;
        font-size: 28px;
        background: #F9F9F9;
        border-radius: 32px;
      }
      .send {
        width: 30%;
        height: 70px;
        color: #fff;
        font-size: 28px;
        line-height: 70px;
        text-align: center;
        background: #ff6c02;
        border-radius: 35px;
      }
    }
    .disableBtn {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 50%;
      color: #A5A5A5;
      font-size: 22px;
      background: #FAFAFA;
      border-radius: 30px;
    }
  }
  .toastStatus {
    position: fixed;
    top: 20%;
    left: 50%;
    z-index: 10;
    height: 80px;
    padding: 0 20px;
    color: #fff;
    font-size: 28px;
    line-height: 80px;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 10px;
    transform: translate(-50%,-50%);
  }
}
</style>
